import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import FormPass from 'components/componentsmall/form_pass'
import './style.css'

export default function UpdateAkun() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    return (
      <>
        <button onClick={handleShow}>
          Ubah Kata Sandi
        </button>
  
        <Modal className="ber-update-profile" size="md" show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Ubah Kata Sandi</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <FormPass cLablePass="lable-update-profile" lablePass="Kata Sandi Sekarang" placePass="Kata sandi sekarang anda" />
          <br />
          <FormPass cLablePass="lable-update-profile" lablePass="Kata Sandi Baru" placePass="Kata sandi baru anda" />
          <br />
          <FormPass cLablePass="lable-update-profile" lablePass="Konfirmasi Kata Sandi" placePass="Konfirmasi kata sandi baru anda" />
          </Modal.Body>
          <Modal.Footer>
            <button onClick={handleClose}>
              Kembali
            </button>
            <button onClick={handleClose}>
              Simpan
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
  